// extracted by mini-css-extract-plugin
export default {"card":"Card_card__b4KXm","smallCard":"Card_smallCard__fqUL1"};